import * as React from "react";
import { Theme, Divider, List } from "@material-ui/core";
import { WithStyles, Typography, ListItem } from "@material-ui/core/";
import { mockTheme } from "../utils/utils";
import { withStyles } from "@material-ui/core/es";

const styles = (theme: Theme) => ({
    root: {
        width: '100%',
        maxWidth: '360px',
        backgroundColor: theme.palette.background.paper,
    },
});

export interface TwoColumnsGridData {
    type?: 'divider' | 'title';
    label?: string;
    value?: any;

    after?(): React.ReactElement<any>;

    renderValue?(): React.ReactElement<any>;

    onPress?(data: TwoColumnsGridData): void;
}

const classesType = styles(mockTheme);

interface TwoColumnsGridProps extends WithStyles<keyof typeof classesType> {
    data: TwoColumnsGridData[],
}

const TwoColumnsGridWithoutStyles = (props: TwoColumnsGridProps) => {


    const renderRow = (row: TwoColumnsGridData, index: number) => {
        const key = (row.type || row.label || 'row') + index;
        if (row.type === 'divider') {
            return (<Divider key={key} />)
        }

        if (row.type === 'title') {
            return (
                <Typography key={key} variant="headline"
                    style={{ textAlign: 'center' }}>
                    {row.label}
                </Typography>
            )
        }

        const after = row.after ? (<div>{row.after()}</div>) : null;

        const body = (
            <div>
                <Typography variant="body1">{row.label}</Typography>
                {row.renderValue ? row.renderValue() : <Typography variant="body2">{row.value}</Typography>}
                {after}
            </div>
        );

        if (row.onPress) {
            const action = row.onPress;
            return (
                <ListItem button key={key}>
                    <div onClick={() => action(row)}>
                        {body}
                    </div>
                </ListItem>
            )
        }
        return <ListItem key={key}>{body}</ListItem>;
    };

    return (
        <div>
            <List component="nav">
                {props.data.map(renderRow)}
            </List>
        </div>);
};

export const TwoColumnsGrid = withStyles(styles as any)(TwoColumnsGridWithoutStyles);


// WEBPACK FOOTER //
// ./src/components/TwoColumnsGrid.tsx